import { normalize } from './matchTeilnehmende'
import { normalizeMassnahmeNummer } from '@/core/lib/massnahme'

export type BewilligungCandidate = {
  coachingId: string
  vorname: string
  nachname: string
  massnahmeNummer: string
  ready: boolean
}

export type BewilligungMatchResult =
  | { kind: 'match'; candidate: BewilligungCandidate }
  | { kind: 'none' }
  | { kind: 'ambiguous' }

export function matchBewilligung(
  person: { nachname: string | null | undefined },
  massnahmeNummer: string | null | undefined,
  candidates: BewilligungCandidate[],
): BewilligungMatchResult {
  const nachname = person.nachname?.trim()
  if (!nachname) return { kind: 'none' }
  const nachnameKey = normalize(nachname)
  const hits = candidates.filter((c) => normalize(c.nachname) === nachnameKey)
  if (hits.length === 0) return { kind: 'none' }
  if (hits.length === 1) return { kind: 'match', candidate: hits[0] }

  const nummer = massnahmeNummer?.trim()
  if (nummer) {
    const narrowed = hits.filter((c) => normalizeMassnahmeNummer(c.massnahmeNummer) === normalizeMassnahmeNummer(nummer))
    if (narrowed.length === 1) return { kind: 'match', candidate: narrowed[0] }
  }
  return { kind: 'ambiguous' }
}
